import React, { useContext } from 'react';
import {
    Grid,
    GridColumn,
    View,
    colors,
    Heading,
    Button,
} from '@fairygodboss/ui';
import window from 'global/window';
import { MailBoxSVG, MailBoxMobileSVG } from './MailBoxSVG';
import { AuthWrapper } from '../../../../pages/HomePage_v2/sections/components/AuthWrapper';
import { EmitMetric } from '../../../Analytics/VisibilityPixel/VisibilityPixel';
import { PageContext } from '../../../../contexts/ContextCreator';

export const CTA = () => {
    const { isLoggedIn } = useContext(PageContext);
    const onEmitMetric = () => {
        EmitMetric({
            misc_event_type: 'value-prop-ad',
            misc_event_count: 1,
            test_flag: 'Single Job Pages',
        });
    };

    return !isLoggedIn() ? (
        <View
            borderBottomStyle="solid"
            borderWidth="1px"
            borderColor={colors.secondary[20]}
            pt="large"
            pb="32px"
            css={{
                color: colors.neutral[100],
                h4: {
                    fontFamily: 'Open Sans, sans-serif',
                },
                button: {
                    fontFamily: 'Open Sans, sans-serif',

                    span: {
                        color: colors.neutral[0],
                        letterSpacing: '-0.4px',
                        overflow: 'inherit',
                    },
                    backgroundColor: colors.secondary[60],
                    ':hover': {
                        backgroundColor: colors.secondary[70],
                    },
                },
            }}
        >
            <Grid>
                <GridColumn size={{ md: 12 }}>
                    <View
                        display="flex"
                        backgroundColor="#F0F2F5"
                        borderRadius="8px"
                        alignItems="center"
                        px={{ _: '24px', sm: '32px' }}
                        py={{ _: '16px', sm: '32px' }}
                        fontFamily="Open Sans, sans-serif"
                    >
                        <View display={{ _: 'none', sm: 'inherit' }}>
                            <MailBoxSVG />
                        </View>
                        <View ml={{ _: '0px', sm: '32px' }}>
                            <View
                                display={{ _: 'flex', sm: 'inherit' }}
                                mb={{ _: '8px', sm: '0px' }}
                                alignItems={{ _: 'center', sm: 'inherit' }}
                            >
                                <View display={{ _: 'inherit', sm: 'none' }}>
                                    <MailBoxMobileSVG />
                                </View>
                                <Heading
                                    fontSize="18px"
                                    lineHeight="24px"
                                    fontWeight="700"
                                    variant="headingMd"
                                    pb={{ _: '0px', sm: '16px' }}
                                    ml={{ _: '16px', sm: '0px' }}
                                >
                                    Get jobs straight to your inbox
                                </Heading>
                            </View>

                            <View
                                ml={{ _: '' }}
                                fontSize="16px"
                                fontWeight="400"
                                lineHeight="24px"
                                mb={{ _: '16px', sm: '24px' }}
                            >
                                Anonymous company reviews, virtual recruiting
                                events, and a supportive community for women
                                when you sign up.
                            </View>
                            <View>
                                <AuthWrapper
                                    component={
                                        <Button
                                            px="28px"
                                            py="14px"
                                            size="large"
                                            variant="secondary"
                                            width={{ _: '100%', sm: '169px' }}
                                            onPress={onEmitMetric}
                                        >
                                            Sign up for free
                                        </Button>
                                    }
                                    redirectUrl={window?.location?.pathname}
                                    loginTrigger="single-job-page"
                                />
                            </View>
                        </View>
                    </View>
                </GridColumn>
            </Grid>
        </View>
    ) : null;
};
